import React, { useContext, useState } from 'react';
import MainAppContext from '../../../../../../MainAppContext';

import { Col, Row } from 'react-bootstrap';
import { IconButton } from '@fluentui/react';
import ChangeComponentType from '../../_ComponentTypes/Dataserie/ChangeComponentType';

import { getBoardVariableDataSerieValues } from '../../../../../../services/sKPI/dataserie.service';
import { updateBoardCompoenet } from '../../../../../../services/sKPI/board.service';
import { enum__ComponentType, __enum_ChartDataserieInputType, enum__ComponentType_InvertedEnum } from '../../../../../../common/Dictionaries';
import moment from 'moment';
import PropTypes from 'prop-types';
import "./style.css"
import BoardAppContext from '../../../../../../BoardAppContext';
import { action_setBoardDataseries, action_updateComponentInfoDataCompare, action_updateBoardFullStructure, action_updateComponentInfoData, action_updateComponentInfoDataChartCompare, action_updateChartSelectedDatapoint, action_setEvents, action_setBoardViewComponentInfoRecursiveValues } from '../../../../../../reducers/actions/KPI/actions';
import { useDispatch, useSelector } from 'react-redux';
import { action_setBoardChartContainerIdSelected } from '../../../../../../reducers/actions/KPI/actions';
import { BOARD_AGGREGATION_WHEN_NULL } from '../../../../../../configurations/application.config';
import { getLocalStorageValue } from '../../../../../../common/Helpers';
import SidePanelAddDataserieVariableValue from '../BoardListNew/SidePanelAddDataserieVariableValue';
import SidePanelEditDataserieVariableValue from '../BoardListNew/SidePanelEditDataserieVariableValue';
import SidePanelDeleteDataserieVariableValue from '../BoardListNew/SidePanelDeleteDataserieVariableValue';
import SidePanelViewDataserieAditionalInfo from '../BoardListNew/SidePanelViewDataserieAditionalInfo';
import SidePanelDataserieClose from '../../BoardElementTypeBox/DataserieClose/SidePanelDataserieClose';
import SidePanelViewDataserieVariableValue from '../BoardListNew/SidePanelViewDataserieVariableValue';

function BoardToolBarList(props) {
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);
    const { _boardStructureGeneric: boardStructureGeneric } = useSelector((state) => state.boardViewScope);
    const { _boardComponentInfoRecursiveValues: boardComponentInfoRecursiveValues } = useSelector((state) => state.boardViewComponentsScope);
    const { _listComponentTypeConfig: listComponentTypeConfig } = useSelector((state) => state.boardViewScope);
    const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);

    const dispatch = useDispatch();

    const { 
        inputParam_UserPropsKpi = null,
        inputParam_BoardId = null,
        inputParam_ElementId = null,
        inputParam_DataserieList = null,
        inputParam_Dataserie = null,
        setBoardVariableDataserieValues = null,
        inputParam_ContainerComponent = null,
        index = null,
    } = props;

    const [isCloseDataseriesPanelOpen, setIsCloseDataseriesPanelOpen] = useState(false);
    const [isViewDataserieVariableValuePanelOpen, setIsViewDataserieVariableValuePanelOpen] = useState(false);
    const [isAddDataserieVariableValuePanelOpen, setIsAddDataserieVariableValuePanelOpen] = useState(false);
    const [isEditDataserieVariableValuePanelOpen, setIsEditDataserieVariableValuePanelOpen] = useState(false);
    const [isDeleteDataserieVariableValuePanelOpen, setIsDeleteDataserieVariableValuePanelOpen] = useState(false);
    const [isViewDataserieInfoPanelOpen, setIsViewDataserieInfoPanelOpen] = useState(false);
    
    const [selectedDataserieToPanel, setSelectedDataserieToPanel] = useState(inputParam_DataserieList !== null && inputParam_DataserieList.length > 0 ? inputParam_DataserieList[0] : null);
    const [selectedDataserieToCompare, setSelectedDataserieToCompare] = useState(null);
    const [calendarType, setCalendarType] = useState(null);

    const onOpenPanel = (type, calendarType, dataSerie, setterCalendarType) => {
        switch (type) {
            case "view":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(true)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "view2":
                setIsViewDataserieVariableValuePanelOpen(true)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "add":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(true)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "edit":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(true)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "delete":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(true)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(false)
                break;
            case "close":
                setIsViewDataserieVariableValuePanelOpen(false)
                setIsAddDataserieVariableValuePanelOpen(false)
                setIsEditDataserieVariableValuePanelOpen(false)
                setIsDeleteDataserieVariableValuePanelOpen(false)
                setIsViewDataserieInfoPanelOpen(false)
                setIsCloseDataseriesPanelOpen(true)
                break;
            default:
                break;
        }

        setSelectedDataserieToPanel(dataSerie)
        
        /*dispatch(action_setBoardChartContainerIdSelected({
            containerId: inputParam_ContainerComponent.containerId,
            dataserieId: inputParam_Dataserie.dataserieId
        }));*/
        setterCalendarType && setterCalendarType(calendarType)
    };

    const onChangeRowDisplayType = (_type, _component) => {
        let error = false;
        _component.componentTypeId = _type;

        const l_structure = (boardStructureGeneric === null || boardStructureGeneric === undefined) ? boardStructureGeneric.l_structure : boardStructureGeneric[0].l_structure;

        l_structure[0].l_container.forEach(container => {
            container.l_components.forEach(component => {
                if (component.id === _component.id) {
                    component.componentTypeId = _type;
                }
            });
        });

        updateBoardCompoenet(_component, _component.id).then((response) => {  
            
            if (error === false && response.data.succeeded) { 
                dispatch(action_updateBoardFullStructure(l_structure))
            }
            else {
                //ERROR
            }
        }).catch((e) => {
            error = true;
        });
        
        if (error === false) {        
            dispatch(action_updateBoardFullStructure(l_structure))
        }
    };

    const onChangeRowAggregationTime = (defaultAggregation, elementId, dataserieId) => {
        let calendarFilterStartDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate !== null ?
        moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodStartDate).format('MM/DD/YYYY') : null;

        let calendarFilterEndDate = contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate !== null ?
        moment(contextSite.kpiModule.boardCalendarFilterConfig.value.periodEndsDate).format('MM/DD/YYYY') : null;
        
        let calendarFilterSelectorId = contextSite.kpiModule.boardCalendarFilterConfig.value.calendarSelectorId;

        getBoardVariableDataSerieValues(inputParam_BoardId, elementId, dataserieId, calendarFilterSelectorId, defaultAggregation ? 2 : 1, calendarFilterStartDate, calendarFilterEndDate).then((response) => {   
            let dataSerieList = boardVariableDataserieValues
            
            for (let index = 0; index < dataSerieList.length; index++) {
                const dataSerie = dataSerieList[index];

                if(dataSerie.dataserieId === dataserieId) {
                    dataSerie.l_vals = response.data.data[0].l_vals;
                    dispatch(action_setBoardDataseries(dataSerieList));
                }
            }
        }).catch((e) => {
        });
    };

    const onChartDataBindClick = (item, chartDataserieInputType) => {

        switch (chartDataserieInputType) {
            case __enum_ChartDataserieInputType.SINGLE:
                setSelectedDataserieToPanel(item)
                dispatch(action_setBoardChartContainerIdSelected({
                    containerId: inputParam_ContainerComponent.containerId,
                    dataserieId: inputParam_Dataserie.dataserieId
                }));
                dispatch(action_updateChartSelectedDatapoint(null));
                dispatch(action_updateComponentInfoData(item, true));

                onChartDataBindClearCompareClick()
                dispatch(action_setEvents(null));

                let componentTypeName = null
                Object.keys(boardComponentInfoRecursiveValues).forEach(key => {
                    if (boardComponentInfoRecursiveValues[key] !== null) {
                        boardComponentInfoRecursiveValues[key].forEach(componentInfo => {
                            if (componentInfo.componentConfig.id.toString() === inputParam_ContainerComponent.htmlOnclick){
                                componentTypeName = key;
                            }
                        });
                    }
                });

                boardComponentInfoRecursiveValues[componentTypeName].forEach(componentInfo => {
                    if (componentInfo.componentConfig.id.toString() === inputParam_ContainerComponent.htmlOnclick) {
                        componentInfo.componentData.items.forEach(componentItemData => {
                            componentItemData.l_dataserie.forEach(dataserie => {
                                dataserie.dataSerieId = item.dataserieId;

                                dataserie.l_vals = item.l_vals;

                                if (dataserie.l_vals.length > 0) {
                                    dataserie.lmax = dataserie.l_vals.reduce((max, current) => {
                                        return current.valueGoalPercent > max ? current.valueGoalPercent : max;
                                    }, dataserie.l_vals[0].valueGoalPercent);
                                } else {
                                    dataserie.lmax = 0;
                                }
                            });
                        });
                    }
                });

                dispatch(action_setBoardViewComponentInfoRecursiveValues(
                        enum__ComponentType_InvertedEnum[inputParam_ContainerComponent.componentTypeId],
                        boardComponentInfoRecursiveValues[componentTypeName]
                    )
                )

                break;
            case __enum_ChartDataserieInputType.MULTIPLE:
                //##Se podria comparar la serie seleccionada de manera normal con la a comparar, si son iguales alertar que no se puede comparar una serie con sigo misma.
                setSelectedDataserieToCompare(true, item)
                dispatch(action_updateComponentInfoDataCompare(item, true))
                break;
            default:
                break;
        }
    }

    const onChartDataBindClearCompareClick = () => {
        setSelectedDataserieToCompare(null)
        dispatch(action_updateComponentInfoDataChartCompare(null, null, false))
    }

    return (
        <Col className={`col-auto d-flex align-self-center pb-1 mb-auto ps-0 ${index === 0 ? ' pt-3 mt-2' : ' pt-0 mt-0'}`} style={{height: "30px"}}>
            <div className={`${index === 0 ? 'pb-1' : '' }`}>
                <ChangeComponentType
                    inputParam_OnChangeRowDisplayType={onChangeRowDisplayType}
                    inputParam_SetCalendarType={setCalendarType}
                    inputParam_OnChangeRowAggregationTime={onChangeRowAggregationTime}
                    inputParam_OnOpenPanel={onOpenPanel}
                    inputParam_Component={inputParam_ContainerComponent}
                    inputParam_DataSerie={inputParam_Dataserie}
                    inputParam_OnSelectSerieToCompareOnChart={onChartDataBindClick}
                    inputParam_OnChartDataBindClearCompareClick={onChartDataBindClearCompareClick}
                    inputParam_SelectedDataserieToPanel={selectedDataserieToPanel}
                    inputParam_HideAggregationButtons={true}
                />
            </div>
            {
                inputParam_DataserieList.filter(x => x.dataserieId === inputParam_Dataserie.dataserieId).length > 0 && inputParam_DataserieList.find(x => x.dataserieId === inputParam_Dataserie.dataserieId).componentTypeId !== enum__ComponentType.CHART && selectedDataserieToCompare === null ?
                <div className={index===0 ? "pb-1" : ""}>
                    <IconButton
                        iconProps={{ iconName: `${ listComponentTypeConfig !== undefined ? (inputParam_ContainerComponent.containerId === listComponentTypeConfig.containerId && inputParam_Dataserie.dataserieId === listComponentTypeConfig.dataserieId ? 'DrillDownSolid' : "DrillDown") : "DrillDown" }` }}
                        onClick={() => onChartDataBindClick(inputParam_DataserieList.find(x => x.dataserieId === inputParam_Dataserie.dataserieId), __enum_ChartDataserieInputType.SINGLE)}
                        styles={{ root: {transform: "rotate(-90deg)"}, icon: { fontSize: 20 } }}
                    />
                </div> :
                <div className={index===0 ? "pb-1" : ""}>
                    <IconButton
                        iconProps={{ iconName: `${  listComponentTypeConfig !== undefined ? (inputParam_ContainerComponent.containerId === listComponentTypeConfig.containerId && inputParam_Dataserie.dataserieId === listComponentTypeConfig.dataserieId ? 'DrillDownSolid' : "DrillDown") : "DrillDown" }` }}
                        styles={{ root: {transform: "rotate(-90deg)"}, icon: { fontSize: 20 } }}
                    />
                </div>
            }
            {
                inputParam_UserPropsKpi && inputParam_DataserieList.filter(x => x.dataserieId === inputParam_Dataserie.dataserieId).length > 0 && inputParam_DataserieList.find(x => x.dataserieId === inputParam_Dataserie.dataserieId).componentTypeId !== enum__ComponentType.CHART && selectedDataserieToCompare !== null && selectedDataserieToPanel !== null && 
                <div className={index===0 ? "pt-1" : ""}>
                    <IconButton
                        style={{ color: `${ inputParam_Dataserie.dataserieId === selectedDataserieToCompare.dataserieId ? "#69AA00" : "" }`}}
                        iconProps={{ iconName: `${ (inputParam_Dataserie.dataserieId === selectedDataserieToCompare.dataserieId || inputParam_Dataserie.dataserieId === selectedDataserieToPanel.dataserieId) ? 'DrillDownSolid' : "DrillDown" }` }}
                        onClick={() => onChartDataBindClick(inputParam_DataserieList.find(x => x.dataserieId === inputParam_Dataserie.dataserieId), __enum_ChartDataserieInputType.SINGLE)}
                        styles={{ root: {transform: "rotate(-90deg)"}, icon: { fontSize: 20 } }}
                    /> 
                </div>
            }

            {
                selectedDataserieToPanel !== null && calendarType !== null &&
                <>
                    <SidePanelViewDataserieVariableValue
                        inputParam_SetterIsPanelOpen={setIsViewDataserieVariableValuePanelOpen}
                        inputParam_ElementId={inputParam_ElementId}
                        inputParam_ElementType={calendarType}
                        inputParam_SetCalendarType={setCalendarType}
                        inputParam_IsPanelOpen={isViewDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                        inputParam_BoardId={inputParam_BoardId}
                    />
                    <SidePanelAddDataserieVariableValue
                        inputParam_SetterIsPanelOpen={setIsAddDataserieVariableValuePanelOpen}
                        inputParam_ElementId={inputParam_ElementId}
                        inputParam_ElementType={calendarType}
                        inputParam_SetCalendarType={setCalendarType}
                        inputParam_IsPanelOpen={isAddDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                        inputParam_BoardId={inputParam_BoardId}
                    />
                    <SidePanelEditDataserieVariableValue
                        inputParam_SetterIsPanelOpen={setIsEditDataserieVariableValuePanelOpen}
                        inputParam_ElementId={inputParam_ElementId}
                        inputParam_ElementType={calendarType}
                        inputParam_IsPanelOpen={isEditDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                        inputParam_BoardId={inputParam_BoardId}
                    />
                    <SidePanelDeleteDataserieVariableValue
                        inputParam_SetterIsPanelOpen={setIsDeleteDataserieVariableValuePanelOpen}
                        inputParam_ElementType={calendarType}
                        inputParam_IsPanelOpen={isDeleteDataserieVariableValuePanelOpen}
                        inputParam_DataSerie={selectedDataserieToPanel}
                        setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                        inputParam_BoardId={inputParam_BoardId}
                    />
                </>
            }
            {
                selectedDataserieToPanel !== null && isCloseDataseriesPanelOpen &&
                <SidePanelDataserieClose
                    inputParam_BoardId={inputParam_BoardId}
                    inputParam_ElementId={selectedDataserieToPanel.elementId}
                    inputParam_DataSerieList={[selectedDataserieToPanel]}
                    inputParam_IsPanelOpen={isCloseDataseriesPanelOpen}
                    inputParam_SetterIsPanelOpen={setIsCloseDataseriesPanelOpen}
                />
            }
            {
                selectedDataserieToPanel !== null && isViewDataserieInfoPanelOpen &&
                <SidePanelViewDataserieAditionalInfo
                    inputParam_SetterIsPanelOpen={setIsViewDataserieInfoPanelOpen}
                    inputParam_IsPanelOpen={isViewDataserieInfoPanelOpen}
                    inputParam_DataSerie={selectedDataserieToPanel}
                    inputParam_SetterDataSerie={setSelectedDataserieToPanel}
                    inputParam_BoardId={inputParam_BoardId}
                />
            }
        </Col>
    );
}

BoardToolBarList.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_DataserieList: PropTypes.array.isRequired,
};

export default BoardToolBarList;